var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vca-card',[_c('vca-card',{staticClass:"text-center shadowed"},[_c('h1',[_vm._v(_vm._s(_vm.text))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }